module.exports = __webpack_public_path__ + "images/embed/icons/reports_multi_select.gif";